import { FigureData } from "../../figure-modal.js";

export function getEnvironmentName(node, state) {
    if (node?.type?.is?.("$Environment")) {
        node = node.getChild("BeginEnv");
    }

    if (!node?.type?.is?.("BeginEnv") && !node?.type?.is?.("EndEnv")) {
        return null;
    }

    const nameNode = node.getChild("EnvNameGroup")?.getChild("OpenBrace")?.nextSibling;
    if (!nameNode || nameNode.type.is("CloseBrace")) {
        return null;
    }

    return state.sliceDoc(nameNode.from, nameNode.to);
}

export const getUnstarredEnvironmentName = (node, state) => getEnvironmentName(node, state)?.replace(/\*$/, "");

export function getEnvironmentArguments(environmentNode) {
    return environmentNode.getChild("BeginEnv")?.getChildren("TextArgument") || [];
}

export function parseFigureData(figureEnvironmentNode, state) {
    let caption = null;
    let label = null;
    let file;
    let width;
    let graphicsCommand = null;
    let graphicsCommandArguments = null;
    let unknownGraphicsArguments;
    let error = false;

    figureEnvironmentNode.cursor().iterate((node) => {
        if (error) {
            return false;
        }
        if (node.type.is("Caption")) {
            if (caption) {
                error = true;
                return false;
            }
            caption = { from: node.from, to: node.to };
        }
        if (node.type.is("Label")) {
            if (label) {
                error = true;
                return false;
            }
            label = { from: node.from, to: node.to };
        }
        if (node.type.is("IncludeGraphics") || node.type.is("IncludeSvg")) {
            if (file) {
                error = true;
                return false;
            }
            graphicsCommand = { from: node.from, to: node.to };
            const argumentNodeName = node.type.is("IncludeSvg") ? "IncludeSvgArgument" : "IncludeGraphicsArgument";
            const argumentNode = node.node.getChild(argumentNodeName);
            const content = argumentNode?.getChild("FilePathArgument")?.getChild("LiteralArgContent");
            if (!content) {
                error = true;
                return false;
            }
            file = {
                from: content.from,
                to: content.to,
                path: state.sliceDoc(content.from, content.to) + (node.type.is("IncludeSvg") ? ".svg" : ""),
            };

            const optionalArgs = argumentNode?.getChild("OptionalArgument");
            const openBracket = optionalArgs?.getChild("OpenBracket");
            const closeBracket = optionalArgs?.getChild("CloseBracket");
            if (optionalArgs && openBracket && closeBracket) {
                graphicsCommandArguments = {
                    from: openBracket.to,
                    to: closeBracket.from,
                };
                unknownGraphicsArguments = state.sliceDoc(graphicsCommandArguments.from, graphicsCommandArguments.to);
            }
            const widthMatch = optionalArgs
                ? state.sliceDoc(optionalArgs.from, optionalArgs.to).match(/width\s*=\s*([0-9.]+)\\textwidth/)
                : null;
            if (widthMatch) {
                width = Number(widthMatch[1]);
                if (/^\s*width\s*=\s*[0-9.]+\\(?:text|line)width\s*$/.test(unknownGraphicsArguments || "")) {
                    unknownGraphicsArguments = "";
                }
            }
        }
        return undefined;
    });

    if (error || !file) {
        return null;
    }

    return new FigureData({
        from: figureEnvironmentNode.from,
        to: figureEnvironmentNode.to,
        caption,
        label,
        file,
        width,
        unknownGraphicsArguments,
        graphicsCommandArguments,
        graphicsCommand,
    });
}
